import { PartialBlob } from "../types";

export const isBlobDeleted = (blob: PartialBlob): boolean =>
  blob.blobModifiedInformation?.deletedStatus?.isDeleted ?? false;

export const isBlobArchived = (blob: PartialBlob): boolean =>
  blob.blobModifiedInformation?.status?.statusName === "Archived";
